import React, { Component } from "react";
import { connect } from "react-redux";
import { openArticleViewer } from "Actions";

import ArticleComponent from "./ArticleComponent";

export class ArticleContainer extends Component {
  handleOpenArticleReveal = e => {
    const { openArticleViewer, article } = this.props;

    openArticleViewer({
      articles: [article],
      isOpen: true,
      currentArticle: article
    });
  };
  render() {
    const { community, article, index } = this.props;

    return (
      <ArticleComponent
        article={article}
        community={community}
        openArticleReveal={this.handleOpenArticleReveal}
        index={index}
      />
    );
  }
}

// Connected Component
const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  openArticleViewer: viewer => dispatch(openArticleViewer(viewer))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArticleContainer);



// WEBPACK FOOTER //
// ./src/components/Community/NewCommunity/Article/ArticleContainer.js